module.exports = [
    {form_type: 'capabilities-capability_category-capability_type', category: 'Education and Outreach', type: 'Awareness Initiative/Public Education'},
    {form_type: 'capabilities-lifelines', category: 'Police Stations', type: 'Police Stations'},
]